"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "casciana-terme-lari": {
    "2cb08287": [{
      "hkey": "06387024",
      "slug": "lavaiano",
      "name": "Lavaiano",
      "primary": true,
      "skipSearch": false
    }],
    "lavaiano-usigliano": [{
      "hkey": "06387024",
      "slug": "lavaiano",
      "name": "Lavaiano",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;